import { CommandBar } from "@fluentui/react";
import { useEffect, useState } from "react";

import {
  CommandBarConfigs,
  ListDataCommandBarCommandBarProps
} from "./interfaces";

export function ListDataCommandBar({
  cfg,
  _paginate,
  resetSelectedItems,
  resetItemsPerPage,
  hasFilters,
  toggleFilterVisibility
}: ListDataCommandBarCommandBarProps): JSX.Element {
  const [componentConfig, setComponentConfig] = useState<CommandBarConfigs>({
    items: [],
    farItems: []
  });

  useEffect(() => {
    const commandBarConfig: CommandBarConfigs = {
      items: [],
      farItems: []
    };

    if (!Array.isArray(cfg)) {
      if (cfg.meta) {
        commandBarConfig.items = [
          {
            key: "back",
            text: "Anterior",
            disabled:
              Number(cfg.meta.currentPage) === 1 ||
              Number(cfg.meta.totalItems) === 0,
            iconProps: { iconName: "Back" },
            onClick: () =>
              _paginate({
                page: Number(cfg.meta.currentPage) - 1
              })
          },
          {
            key: "next",
            text: "Próxima",
            iconProps: { iconName: "Forward" },
            disabled:
              Number(cfg.meta.currentPage) === cfg.meta.totalPages ||
              Number(cfg.meta.totalItems) === 0,
            onClick: () =>
              _paginate({
                page: Number(cfg.meta.currentPage) + 1
              })
          }
        ];
      }
    }

    if (hasFilters) {
      commandBarConfig.farItems.unshift({
        key: "cleanFilters",
        text: "Limpar Filtros",
        ariaLabel: "Limpar Filtros",
        iconOnly: true,
        iconProps: { iconName: "ClearFilter" },
        onClick: () => {
          resetSelectedItems();
          resetItemsPerPage();
        }
      });
      commandBarConfig.farItems.unshift({
        key: "filter",
        text: "Filtros",
        // This needs an ariaLabel since it's icon-only
        ariaLabel: "Filtros",
        iconOnly: true,
        iconProps: { iconName: "Filter" },
        onClick: toggleFilterVisibility
      });
    }

    setComponentConfig(commandBarConfig);
  }, [cfg]);

  return (
    <CommandBar
      items={componentConfig.items}
      farItems={componentConfig.farItems}
      styles={{
        root: {
          padding: 0
        }
      }}
    />
  );
}
